<template>
  <modal :title="hotelName" size="xl" @close="$emit('close')">
    <template #content>
      <ul
        class="nav nav-tabs profile-tab"
        style="overflow: auto hidden; margin-bottom: 0px;"
      >
        <li><a href="javascript:;" class="nav-link" :class="{'active':tab==''}" @click="tab=''">Genel</a></li>
        <li v-for="item in data.RoomTypes" :key="item"><a href="javascript:;" class="nav-link" :class="{'active':tab==item}" @click="tab=item">{{item}}</a></li>
      </ul>
      <apexChart :data="getDatasets" :key="tab"></apexChart>
      <dataTable
        v-if="!process && Object.keys(data).length > 0"
        :name="'RoomAvailibilityDetail'"
        ref="agGrid"
        :data="getData"
        :columnDefs="getColumns"
        @cellClicked="detailShow = $event?.data"
      ></dataTable>
    </template>
  </modal>
</template>

<script>
import apexChart from "../../../components/apexChart.vue";
export default {
  name: "Detail",
  props: ["data","hotelName"],
  components: {
    apexChart,
  },
  data(){
    return{
        tab:""
    }
  },
  computed: {
    getDatasets() {
      var data = [];
      var percent = 0;
      this.data.Rows.forEach((element) => {
        if(this.tab==''){
            percent = (element.TotalEmpty + element.TotalFilled) / 100;
            data.push({
            x: this.$moment(new Date(element.Date)).format("DD.MM"),
            y: element.TotalFilled,
            fillColor:
                element.TotalEmpty / percent < 6
                ? "#fc4b6c"
                : element.TotalEmpty / percent < 16
                ? "#ffb22b"
                : element.TotalEmpty / percent < 26
                ? "#ffef2b"
                : "#55ce63",
            goals: [
                {
                name: "Kapasite",
                value: element.TotalEmpty + element.TotalFilled,
                strokeColor: "#1e88e5",
                },
            ],
            });
        }else{
            if(element.RoomTypes.filter(x=>{return x.Name==this.tab}).length==0){
                return false;
            }
            percent = (element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Empty + element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Filled) / 100;
            data.push({
            x: this.$moment(element.Date).format("DD.MM"),
            y: element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Filled,
            fillColor:
                element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Empty / percent < 6
                ? "#fc4b6c"
                : element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Empty / percent < 16
                ? "#ffb22b"
                : element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Empty / percent < 26
                ? "#ffef2b"
                : "#55ce63",
            goals: [
                {
                name: "Kapasite",
                value: element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Empty + element.RoomTypes.filter(x=>{return x.Name==this.tab})[0].Filled,
                strokeColor: "#1e88e5",
                },
            ],
            });
        }
      });
      return [
        {
          name: "Doluluk",
          data: data,
        },
      ];
    },
    getData() {
      let data = [];
      this.data.RoomTypes.forEach((room) => {
        let r = {
          Name: room,
        };
        this.data.Rows.forEach((row) => {
          row.RoomTypes.forEach((type) => {
            if (type.Name == room) {
              r[this.$moment(new Date(row.Date)).format("DD/MM")] = type.Empty;
              r[this.$moment(new Date(row.Date)).format("DD/MM") + "F"] =
                type.Filled;
            }
          });
        });
        data.push(r);
      });
      return data;
    },
    getColumns() {
      let columnDefs = [
        {
          headerName: "Room Name",
          field: "Name",
          enableRowGroup: false,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
      ];
      this.data.Rows.forEach((row) => {
        columnDefs.push({
          headerName: this.$moment(new Date(row.Date)).format("DD/MM"),
          field: this.$moment(new Date(row.Date)).format("DD/MM"),
          enableRowGroup: false,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          width: 100,
          cellStyle: (params) => {
            let percent =
              (params.data[
                this.$moment(new Date(row.Date)).format("DD/MM") + "F"
              ] +
                params.data[this.$moment(new Date(row.Date)).format("DD/MM")]) /
              100;
            console.log("percent", percent, params.value,params.data);
            if (params.value / percent < 6) {
              return { color: "#fff", backgroundColor: "#fc4b6c" };
            } else if (params.value / percent < 16) {
              //mark police cells as red
              return { color: "#fff", backgroundColor: "#ffb22b" };
            } else if (params.value / percent < 26) {
              //mark police cells as red
              return { backgroundColor: "#ffef2b" };
            } else if(percent>0) {
              return { color: "#fff", backgroundColor: "#55ce63" };
            }
          },
        });
      });
      return columnDefs;
    },
  },
};
</script>

<style></style>
